import React from 'react';

let open = false

export default class DropdownInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  handleClick(e) {
    if (!this.refs.popover.contains(e.target)) {
      this.setState({open: false});
    }
  }

  componentWillMount() {
    document.addEventListener('click', this.handleClick.bind(this), false);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick.bind(this), false);
  }

  get styles() {
    return {
      dropdownContainer: {
        marginLeft: '-15px',
      },
      dropdown: {
        position: 'relatve',
      },
      dropdownToggle: {
        fontSize: '2rem',
        MozUserSelect: 'none',
        WebkitUserSelect: 'none',
        msUserSelect: 'none',
        userSelect: 'none',
      },
      dropdownContent: {
        top: '35px',
        right: '0px',
        maxWidth: 'initial',
        minHeight: '300px',
        marginBottom: '20px',
        display: this.state.open ? 'block' : 'none',
      },
    };
  }

  toggle() {
    this.setState({open: !this.state.open});
  }

  handleFocus(e) {
    e.target.blur();
    this.toggle();
  }

  render() {
    return (
      <div className="form-group col-sm-12">
        <div ref='popover' className="input-group col-sm-6 col-md-3" style={this.styles.dropdownContainer}>
          <input type="text" className="form-control" onFocus={this.handleFocus.bind(this)} />
          <div ref='toggle' className="input-group-addon" style={this.styles.dropdownToggle} onClick={this.toggle.bind(this)}>📅</div>
          <div ref='content' className="popover fade bottom in" style={this.styles.dropdownContent}>
            <div className="arrow"></div>
            <div className="popover-content">yes it is working</div>
          </div>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/DropdownInput.jsx